import { render, staticRenderFns } from "./rule.vue?vue&type=template&id=b2d7e8f4&scoped=true"
import script from "./rule.vue?vue&type=script&lang=js"
export * from "./rule.vue?vue&type=script&lang=js"
import style0 from "./rule.vue?vue&type=style&index=0&id=b2d7e8f4&prod&lang=scss&scoped=true"
import style1 from "./rule.vue?vue&type=style&index=1&id=b2d7e8f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d7e8f4",
  null
  
)

export default component.exports